shadow$provide[235] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Latch:{enumerable:true, get:function() {
  return Latch;
}}});
var require$_DOT__DOT__SLASH_base_SLASH_parent_DOT_js = require("../base/parent.js");
var require$lodash_SLASH_cloneDeep = require("lodash/cloneDeep");
var require$lodash_SLASH_isEqual = require("lodash/isEqual");
var default$$require$lodash_SLASH_cloneDeep = require.esmDefault(require$lodash_SLASH_cloneDeep);
var default$$require$lodash_SLASH_isEqual = require.esmDefault(require$lodash_SLASH_isEqual);
class Latch extends require$_DOT__DOT__SLASH_base_SLASH_parent_DOT_js.Parent {
  static initClass() {
    this.traits = ["node", "entity", "active", "latch"];
  }
  init() {
    this.data = undefined;
    this.isDirty = true;
  }
  make() {
    this._helpers.active.make();
    this._listen("root", "root.update", function() {
      if (this.isActive) {
        this.update();
      }
    });
  }
  unmake() {
    this._helpers.active.unmake();
    this.data = undefined;
  }
  swap() {
    const {deep, data} = this.props;
    const dirty = deep ? !(0,default$$require$lodash_SLASH_isEqual.default)(data, this.data) : data != this.data;
    if (dirty) {
      this.data = deep ? (0,default$$require$lodash_SLASH_cloneDeep.default)(data) : data;
    }
  }
  update() {
    this.isDirty = this.swap();
  }
}
Latch.initClass();

};